import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar, PieChart, Pie, Cell, Legend } from "recharts";
import { platformLabel } from "../lib/platforms";

const COLORS = ["#E53935", "#FAFAFA", "#A1A1AA", "#404040"];

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/overview").then(r => setData(r.data)); }, []);
  if (!data) return <div className="p-12">Loading…</div>;

  const pieData = data.platforms.map(p => ({ name: platformLabel(p.platform), value: p.clicks }));

  return (
    <div className="p-8 lg:p-12" data-testid="admin-analytics">
      <p className="overline text-white/40">Insights</p>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mt-2 mb-10">Analytics.</h1>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="admin-card p-6 lg:col-span-2">
          <p className="overline text-white/40">Daily clicks · 14 days</p>
          <div className="h-72 mt-4">
            <ResponsiveContainer>
              <LineChart data={data.daily_clicks}>
                <CartesianGrid stroke="#1f1f1f" strokeDasharray="3 3" />
                <XAxis dataKey="date" stroke="#666" fontSize={11} />
                <YAxis stroke="#666" fontSize={11} />
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #2a2a2a" }} />
                <Line type="monotone" dataKey="clicks" stroke="#E53935" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="admin-card p-6">
          <p className="overline text-white/40">Share by platform</p>
          <div className="h-72 mt-4">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={pieData} dataKey="value" nameKey="name" outerRadius={80} innerRadius={50}>
                  {pieData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #2a2a2a" }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="admin-card p-6 lg:col-span-3">
          <p className="overline text-white/40">Top performing products</p>
          <div className="h-72 mt-4">
            <ResponsiveContainer>
              <BarChart data={data.top_products.map(p => ({ name: p.title.slice(0, 18), clicks: p.clicks }))}>
                <CartesianGrid stroke="#1f1f1f" strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="#666" fontSize={11} />
                <YAxis stroke="#666" fontSize={11} />
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #2a2a2a" }} />
                <Bar dataKey="clicks" fill="#E53935" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
